
import React from "react";
import { useNavigate } from "react-router-dom";
import Placeholder from "./placeholder";

export default function CalendarView() {
  return <Placeholder title="Project Calendar" description="Calendar view of all project activities, milestones, and deadlines" returnPath="/dashboard" returnLabel="Back to Dashboard" />;
}
